<template>
  <section class="desc-page content-padd" :class="{ isMobile }">
    <div class="desc-content content-width">
      <div class="desc-title">
        <h2 class="title-underline dc">
          {{ title }}
        </h2>
      </div>
      <div class="constent-text edited-html" v-html="content"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LibSectionDesc",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.desc-page {
  background: var(--c-primary);
  color: #fff;
  text-wrap: pretty;

  .desc-content {
    display: flex;
    // gap: 40px;
  }

  .desc-title {
    margin-bottom: 50px;
    flex: 1 0;
  }
  // .desc-part-1 {
  //   flex: 1 0;
  // }
  // .desc-part-2 {
  //   flex: 1 0;
  // }

  .constent-text {
    flex: 2 0;
    column-count: 2;
    column-gap: 40px;
    p,
    ul,
    div {
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
    }
    h3 {
      -webkit-column-break-after: avoid;
      page-break-after: avoid;
      break-after: avoid;
    }
  }

  &.isMobile {
    .desc-content {
      display: block;
    }
    .constent-text {
      column-count: 1;
    }
  }
}
</style>
